export const SMALL_BUTTON_LOADER_SIZE = 10
